import { render, staticRenderFns } from "./list-odds.vue?vue&type=template&id=5fe1be2f"
import script from "./list-odds.vue?vue&type=script&lang=js"
export * from "./list-odds.vue?vue&type=script&lang=js"
import style0 from "./list-odds.vue?vue&type=style&index=0&id=5fe1be2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports